import { Component } from '@angular/core';

@Component({
  selector: 'dm-page-home',
  templateUrl: './layout.component.html',
})
export class LayoutComponent {
  constructor() {}
}
